import { instanceOEF, segundaVersaoOEF } from './api'

export const postReativarAssinaturaAPI = dadosReativacao => {
  return instanceOEF.post(
    `${segundaVersaoOEF}/reativar-assinatura/`,
    { ...dadosReativacao }
  )
}
